<template>
  <div :class="'logo-container-' + layout">
    <div>
      <!-- 这里是logo变更的位置 -->
      <!-- <vab-remix-icon v-if="logo" class="logo" :icon-class="logo" /> -->
      <img src="@/assets/common_images/logo.png" alt="" srcset="" v-if="logo" :class="collapse ? 'logo collapseLogo' : 'logo'" />
      <span
        class="title"
        :class="{ 'hidden-xs-only': layout === 'horizontal' }"
        :title="title"
        v-if="!collapse"
      >
        {{ title }}
      </span>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'VabLogo',
    props: {
      collapse: {
        type: Boolean,
        default() {
          return false
        },
      }
    },
    data() {
      return {
        title: this.$baseTitle,
      }
    },
    computed: {
      ...mapGetters({
        logo: 'settings/logo',
        layout: 'settings/layout',
      }),
    },
  }
</script>
<style lang="scss" scoped>
  @mixin container {
    position: relative;
    height: $base-top-bar-height;
    overflow: hidden;
    line-height: $base-top-bar-height;
    background: $base-menu-background;
    border-bottom: 1px solid rgba(204,204,204,.5);
  }

  @mixin logo {
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-right: 10px;
    color: $base-title-color;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }
  @mixin collapseLogo {
    margin-left: 12px;
  }

  @mixin title {
    display: inline-block;
    overflow: hidden;
    font-size: 18px;
    // line-height: 55px;
    color: $base-title-color;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .logo-container-horizontal {
    @include container;

    .logo {
      @include logo;
    }
    .collapseLogo {
      @include collapseLogo;
    }

    .title {
      @include title;
    }
  }

  .logo-container-vertical {
    @include container;
    box-sizing: border-box;
    height: $base-logo-height;
    line-height: $base-logo-height;
    // text-align: center;
    // text-indent: 30px;
    padding-left: 27px;
    .logo {
      @include logo;
      // display: none;
    }
    .collapseLogo {
      @include collapseLogo;
    }

    .title {
      @include title;
      font-weight: 600;
      max-width: calc(#{$base-left-menu-width} - 60px);
    }
  }
</style>
